import { render } from "./add_prescription_modal.vue?vue&type=template&id=63708ac0"
import script from "./add_prescription_modal.vue?vue&type=script&lang=js"
export * from "./add_prescription_modal.vue?vue&type=script&lang=js"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__